module.exports = __webpack_public_path__ + "static/media/135U12_Bathroom.6f029297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U12_Bathroom.jpg
// module id = 546
// module chunks = 0